<template>

    <div class="modal-view" v-if="isShow">
        <transition name="modal-bounce">
            <div class="content w-40">
                <div class="header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        @click="hide"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <p class="title mb-0">注意！</p>
                </div>
                <div class="body">
                    <div class="mb-2">
                        <p class="mb-0">查詢晶片/腳環/發報器, 並進行媒合病歷確認</p>
                        <small class="text-warning">*如無晶片/腳環/發報器,可直接前往新增病歷</small>
                    </div>
                    <div class="mb-2">
                        <div class="input-group mb-2">
                            <input type="text" class="form-control" placeholder="請輸入關鍵字搜尋"
                                v-model="search.keyword"
                                @keyup.enter="searchTracingDevice"
                            >
                            <span class="input-group-text"
                                @click="searchTracingDevice"
                            >
                                <i class="align-middle fas fa-fw fa-search"></i>
                            </span>
                        </div>
                    </div>
                    <div>
                        <span>查詢結果:</span>
                        <!-- 找到的病歷資料 -->
                        <div v-for="(record,index) in medicalRecords" :key="index"
                            class="health-record-item"
                            :class="{'selected':healthRecordTargetID === record.id}"
                            @click="selectedTargetHealthRecordHandle( record )"
                        >
                            <div class="item">
                                <span>病歷編號:</span>
                                <span>{{ record.serial_no }}</span>
                            </div>
                            <div>
                                <div v-if="record.species_id != species_id"
                                    class="tips me-1">
                                    <span class="tips-title"><i class="align-middle fas fa-fw fa-exclamation-circle text-danger"></i></span>
                                    <span class="tips-note">該病例與物種不符</span>
                                </div>
                                <span>物種名稱:</span>
                                <span>
                                    <span>{{ record.species_name }}</span>
                                </span>
                            </div>
                            <div>
                                <span>病歷狀態:</span>
                                <span>{{ getStatus(record.medical_status_id) }}</span>
                            </div>
                            <div v-if="record.acknowledgment_id !== ''">
                                <span>已關聯受理單:</span>
                                <span>{{ record.acknowledgment_sn }}</span>
                            </div>
                        </div>
                        <!-- 沒有找到病歷資料 -->
                        <div
                            class="health-record-item-not-find"
                            @click="selectedTargetHealthRecordHandle(null)"
                        >
                            <div>
                                <span>無</span>
                            </div>
                        </div>
                    </div>
                    <div class="pt-2 pb-4">
                        <button class="btn btn-outline-primary w-100"
                            v-if="healthRecordTargetID === null"
                            @click="addHealthRecord"
                        >前往新增病歷</button>
                        <button class="btn btn-primary w-100"
                            v-if="healthRecordTargetID !== null"
                            @click="linkHealthRecord"
                        >使用此病歷編號</button>
                    </div>
                </div>
            </div>
        </transition>
        
    </div>
</template>
<script>

export default {
    name:'linkHealthRecordView',
    props:{
        species_id:{
            type:Number,
            default:-1
        }
    },
    data(){
        return {
            isShow:false,
            healthRecordTargetID:null,
            id:parseInt( this.$route.params.id ),
            medicalRecords:[],
            search:{
                keyword:''
            },
            death_json:null
        }
    },
    components: {
        
    },
    methods:{
        getStatus(status_id){
            const status = this.$parameters.statusList.find(item=>item.id===status_id)
            return status ? status.name : 'N/A'
        },
        selectedTargetHealthRecordHandle(target){

            this.$debug(`target:`,target)

            if ( target == null ){
                this.healthRecordTargetID = null
                return
            }

            //先處理是否有受理單
            if ( //這裡代表沒有受理單，所以直接綁定
                target.acknowledgment_id == null ||
                target.acknowledgment_id == '' ||
                target.acknowledgment_id == undefined ||
                target.acknowledgment_id < 1
            ){
                this.healthRecordTargetID = target.id
                return
            }

            //這裡開始處理有受理單需要判斷
            if ( //判斷受理單跟病歷狀態都要大於91等於已經不在院內了
                target.acknowledgment_status_id >= 91 &&
                target.medical_status_id >= 91
            ){
                this.healthRecordTargetID = target.id
                return
            }
            alert('此病歷已有正在治療中的受理單，不可重複綁定')
            return
        },
        async linkHealthRecord(){
            if (
                !this.$api.users.checkPermission('medical') ||
                !this.$api.users.checkSubPermission('medical','create')
            ){
                return alert('您的病歷相關權限不足，請洽帳號權限管理人員')
            }
            if ( 
                !this.$api.users.checkPermission('ftm') ||
                !this.$api.users.checkSubPermission('ftm','create')
            ){
                return alert('新增病歷需要進行初次檢傷，但您沒有初次檢傷的相關權限，請洽帳號權限管理人員')
            }

            if ( this.healthRecordTargetID == null || this.healthRecordTargetID == -1 ){
                return
            }

            let objFrom = new FormData()
            objFrom.append('id',this.id)
            objFrom.append('medical_record_id',this.healthRecordTargetID)
            //呼叫API將受理單跟病歷綁定再一起，成功後再回傳病歷編號 this.healthRecordTargetID + this.intake_id = this.id
            this.$store.state.loadingStatus = true
            const res = await this.$api.intake.updAknowledgmentFormMedicalId(objFrom)
            this.$store.state.loadingStatus = false
            if (res.code !== 200){
                return alert('綁定失敗')
            }
            //綁定成功後判斷是否關聯病歷
            if ( this.death_json != null ){
                // localStorage.setItem('intake_death',{
                //     intake_id: intake_id,
                //     death_json: this.death_json
                // })
                //處理更新病歷
                //先取得病歷
                this.$store.state.loadingStatus = true
                const mRes = await this.$api.medical.getMedicalrecordById({ id: this.healthRecordTargetID })
                this.$store.state.loadingStatus = false
                if ( mRes.code !== 200 ){
                    return
                }
                let formData = mRes.data
                formData.create_time = this.$shared.formatIosDate(formData.create_time)
                formData.status_id = 94
                //更新病歷
                let objFrom = new FormData()
                objFrom.append('id',formData.medical_record_id)    
                objFrom.append('main_doctor',formData.main_doctor)
                objFrom.append('species_category_id',formData.species_category_id)
                objFrom.append('species_id',formData.species_id)
                objFrom.append('tracking_device_sn',formData.tracking_device_sn)
                objFrom.append('alias_name',formData.alias_name)
                objFrom.append('characteristics',formData.characteristics)
                objFrom.append('gender_id',formData.gender_id)
                objFrom.append('pregnancy_status',formData.pregnancy_status)
                objFrom.append('location_id',formData.location_id)
                objFrom.append('latest_weight',formData.latest_weight)
                objFrom.append('status_id',formData.status_id)
                objFrom.append('death_json', JSON.stringify(this.death_json))

                this.$store.state.loadingStatus = true
                const res = await this.$api.medical.updMedicalrecord(objFrom)
                this.$store.state.loadingStatus = false
                if ( res.code !== 200 ){
                    this.$store.state.actionResult.show({status:'fail',massage:res.msg})
                    return
                }
                
            }

            this.$router.push(`/healthRecord/detail/${this.healthRecordTargetID}/initExamine/create/${this.id}`)
        },
        addHealthRecord(){

            if (
                !this.$api.users.checkPermission('medical') ||
                !this.$api.users.checkSubPermission('medical','create')
            ){
                return alert('你沒有新增病歷的權限，請洽帳號權限管理人員')
            }

            if ( 
                !this.$api.users.checkPermission('ftm') ||
                !this.$api.users.checkSubPermission('ftm','create')
            ){
                return alert('新增病歷需要進行初次檢傷，但您沒有初次檢傷的權限，請洽帳號權限管理人員')
            }

            const intake_id = this.id //該受理單編號
            let is_death = ''
            if ( this.death_json != null ){
                localStorage.setItem('intake_death',JSON.stringify({
                    intake_id: intake_id,
                    death_json: this.death_json
                }))
                is_death = '?is_death=true'
            }
            this.$router.push(`/healthRecord/create/${intake_id}${is_death}`)
        },
        show(death_json=null){
            this.death_json = death_json
            this.isShow = true
        },
        hide(){
            this.death_json = null
            this.isShow = false
        },
        async searchTracingDevice(){
            if ( this.search.keyword.trim() === ''){
                return alert('請輸入晶片/腳環/發報器編號，如無請點選前往新增病歷')
            }
            this.medicalRecords = []
            this.$store.state.loadingStatus = true
            const res = await this.$api.medical.getMedicalrecordByTracingDeviceSn({
                keyword:this.search.keyword
            })
            this.$store.state.loadingStatus = false
            this.$debug(res)
            if ( res.code !== 200 ){
                return
            }
            this.medicalRecords = res.data
        },
    },
    async mounted(){
        
    },
    async created(){
        
    }
  };
</script>
<style scoped>
.health-record-item {
    display: flex;
    padding: 0.5rem 0.5rem;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 0.5rem;
    cursor: pointer;
}
.health-record-item:hover{
    background-color: #e2e0e0;
    color: #103568;
}
.health-record-item.selected{
    background-color: #e2e0e0;
    color: #103568;
}
.health-record-item-not-find{
    cursor: default;
    display: flex;
    padding: 0.5rem 0.5rem;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 0.5rem;
}
.health-record-item > div {
    flex: 0.33;
}
</style>